import { fetchAuthSession } from './amplifyAuth';
import { checkProfileComplete, checkTermsAccepted, checkFocuses } from '../components/API';

/**
 * After sign-in completes, navigate to the appropriate page.
 * Doctors skip the profile check and go straight to /doctor.
 * Patients check profileComplete via DynamoDB to decide between /home and /complete-profile.
 * After profile is complete, checks whether the user has accepted the latest terms.
 */
export async function completeSignInAndRedirect(navigate, redirectPath = null) {
    // Doctors bypass profile flow entirely
    try {
        const session = await fetchAuthSession();
        const groups = session.tokens?.idToken?.payload['cognito:groups'] || [];
        if (groups.includes('Doctors')) {
            navigate('/doctor');
            return;
        }
    } catch { /* fall through to normal flow */ }

    if (redirectPath && redirectPath.startsWith('/') && !redirectPath.startsWith('//')) {
        navigate(redirectPath);
        return;
    }
    try {
        const { profileComplete } = await checkProfileComplete();
        if (profileComplete) {
            const { termsAccepted } = await checkTermsAccepted().catch(() => ({ termsAccepted: false }));
            if (!termsAccepted) {
                navigate('/accept-terms');
            } else {
                const skipUntil = localStorage.getItem('bloodeye_focus_skipped_until');
                if (skipUntil && Date.now() < parseInt(skipUntil, 10)) {
                    navigate('/home');
                } else {
                    const { hasFocuses } = await checkFocuses().catch(() => ({ hasFocuses: false }));
                    navigate(hasFocuses ? '/home' : '/select-focus');
                }
            }
        } else {
            navigate('/complete-profile');
        }
    } catch {
        navigate('/complete-profile');
    }
}
